import clsx from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
// eslint-disable-next-line @luxuryescapes/private-modules
import { _ListItemElement } from '../List/_ListItem'

export const StyledModalContent = styled.div`
  --modal-content-gutter: ${rem(20)};
  --modal-content-vertical-gutter: ${rem(20)};
  padding: var(--modal-content-vertical-gutter) var(--modal-content-gutter);

  ${mediaQueryUp.tablet} {
    --modal-content-gutter: ${rem(24)};
    --modal-content-vertical-gutter: ${rem(24)};
  }

  &.flush {
    --modal-content-gutter: 0;
  }

  &.flush-vertical-top {
    padding-top: 0;
  }

  &.flush-list-items {
    ${_ListItemElement} {
      width: calc(100% + var(--modal-content-gutter) * 2);
      padding-inline: var(--modal-content-gutter);
      margin-left: calc(var(--modal-content-gutter) * -1);
    }
  }

  &:empty {
    display: none;
  }
`

interface ModalContentProps extends PropsWithChildren {
  className?: string
  /**
   * Removes horizontal padding
   */
  flush?: boolean

  /**
   * Removes top padding
   */
  flushVerticalTop?: boolean

  /**
   * Whether or not to make all child list items flush with the edge of the modal
   */
  flushListItems?: boolean
}

/**
 * @description This component is the wrapper for modal content that applies proper paddings.
 * It should never come before `ModalHeader.tsx` or after `ModalFooter.tsx`.
 * @see `Modal.tsx` for usage
 * */
function ModalContent({ children, className, flush, flushVerticalTop, flushListItems }: ModalContentProps) {
  return <StyledModalContent className={clsx(className, { flush, 'flush-vertical-top': flushVerticalTop, 'flush-list-items': flushListItems })}>
    {children}
  </StyledModalContent>
}

export default ModalContent
